import { useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { LeftCircleOutlined } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { ConditionGeneraleApi } from "../../api/conditionGeneraleApi";
import { typeUsers, documentTypes } from "./constants";

const CreateConditionGeneraleView = () => {
    const navigate = useNavigate();
    const abortController = new AbortController();

    const [formData, setFormData] = useState({
        type: 'CGV',
        type_user:'ALL',
        title: '',
        content: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleContentChange = (value) => {
        setFormData({ ...formData, content: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await ConditionGeneraleApi.storeDocument(JSON.stringify(formData), abortController.signal);

            if (!res.success) {
                setLoading(false);
                return Swal.fire({
                    title: "Impossible d'enregistrer",
                    text: res.message,
                });
            }

            message.success('Document juridique créé avec succès');
            navigate('/conditions-generales');
        } catch (error) {
            setLoading(false);
            message.error("Une erreur est survenue lors de la création du document");
            const messages = await error?.messages ?? error?.message;

            if (messages instanceof Array)
                return Swal.fire({
                    title: messages.join('\n') !== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                    text: messages.join('\n') !== 'Unauthenticated' ? "Veuillez vous reconncter." : "Votre session a expirée veuillez vous reconnecter",
                    icon: "error",
                }).then(() => {
                    if (messages.join('\n') === 'Unauthenticated') {
                        Auth.removeSessionToken();
                        return navigate(`/login`);
                    }
                });
        } finally {
            setLoading(false);
        }
    };

    return <MainLayout>
        <div className="container mx-auto p-6">
            <div className="flex justify-between">
                <h1 className="text-3xl font-semibold mb-6">Ajouter un document juridique</h1>
                <Link to={`/conditions-generales`}><LeftCircleOutlined /> Retour  </Link>
            </div>

            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4">
                 <div className="col-12 col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    <label className="block text-sm font-medium mb-1">Type de document</label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        required
                    >
                        {documentTypes.map((docType) => (
                            <option key={docType.value} value={docType.value}>{docType.label}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    <label className="block text-sm font-medium mb-1">Public cible</label>
                    <select
                        name="type_user"
                        value={formData.type_user}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        required
                    >
                        {typeUsers.map((typeUser) => (
                            <option key={typeUser.value} value={typeUser.value}>{typeUser.label}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium mb-1">Titre</label>
                    <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium mb-1">Contenu</label>
                    <ReactQuill theme="snow" value={formData.content} onChange={handleContentChange} className="bg-white" />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="mt-4 px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary disabled:opacity-50"
                >
                    {loading ? 'Enregistrement...' : 'Enregistrer'}
                </button>
            </form>
        </div>
    </MainLayout>
}

export default CreateConditionGeneraleView
